import errorMessage from "./ErrorMessages/errorMessages_en";
import errorMessage_es from "./ErrorMessages/errorMessages_es";
import errorMessage_fr from "./ErrorMessages/errorMessages_fr";
import errorMessage_it from "./ErrorMessages/errorMessages_it";
import errorMessage_pt from "./ErrorMessages/errorMessages_pt";
import errorMessage_he from "./ErrorMessages/errorMessages_he";
import errorMessage_ar from "./ErrorMessages/errorMessages_ar";

const getCookie = (name) => {
    let match;
    if (typeof window !== 'undefined') {
        match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    }
    return match ? match[2] : 'en';
};


const showErrorMessage = async ({ errorCode, error, language }) => {
    const lang = language ? language : getCookie("lang");
    const errorMessages = {
        'en': errorMessage,
        'en-US': errorMessage,
        'es': errorMessage_es,
        'fr-FR': errorMessage_fr,
        'fr': errorMessage_fr,
        'it': errorMessage_it,
        'pt': errorMessage_pt,
        'it-IT': errorMessage_it,
        'pt-PT': errorMessage_pt,
        'ar': errorMessage_ar,
        'he': errorMessage_he
    };

    const messages = errorMessages[lang] || errorMessage;

    return await messages(errorCode, error);
}
export default showErrorMessage;